import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { API } from "@/lib/api";

/**
 * Subscribes to /api/notifications/stream via Server-Sent Events.
 * Calls onMessage({type, data}) for every push.
 * Auto-reconnects on error.
 */
export default function useNotificationStream(enabled, onMessage) {
  const ref = useRef(null);
  const handlerRef = useRef(onMessage);
  handlerRef.current = onMessage;

  useEffect(() => {
    if (!enabled) return;
    const token = localStorage.getItem("hs_access_token") || "";
    let es;
    let stopped = false;
    let retry = 0;

    const connect = () => {
      if (stopped) return;
      const url = `${API}/notifications/stream${token ? `?token=${encodeURIComponent(token)}` : ""}`;
      es = new EventSource(url, { withCredentials: true });
      ref.current = es;
      es.onopen = () => { retry = 0; };
      es.onmessage = (ev) => {
        try {
          const payload = JSON.parse(ev.data);
          handlerRef.current?.(payload);
          if (payload?.type === "notification" && payload?.data?.title) {
            toast(payload.data.title, { description: "Live update", duration: 4000 });
          }
        } catch {}
      };
      es.onerror = () => {
        es.close();
        if (stopped) return;
        retry = Math.min(retry + 1, 6);
        setTimeout(connect, 1000 * 2 ** retry);
      };
    };
    connect();

    return () => {
      stopped = true;
      try { es && es.close(); } catch {}
    };
  }, [enabled]);
}
